export const resetClassNames = [
  'relative m-0 transition ease-in-out duration-150',
  'font-display text-display font-600 leading-8 antialiased',
  'border-0 appearance-none outline-none select-none',
];

const paddingClassNames = {
  none: 'p-0',
  standard: 'px-8 py-4 sm:px-12 sm:py-4',
};

const radiusClassNames = {
  standard: 'rounded-2',
};

const variantClassNames = {
  default: 'text-cyan-700 bg-cyan-50 hover:bg-cyan-100 focus:bg-cyan-100',
  primary: 'text-white bg-cyan-500 hover:bg-cyan-600 focus:bg-cyan-600',
};

type UseButtonStylesProps = {
  disabled?: boolean;
  padding: 'none' | 'standard';
  radius?: 'standard';
  appearance: 'default' | 'primary';
};

export const useButtonStyles = ({
  disabled,
  padding,
  radius = 'standard',
  appearance,
}: UseButtonStylesProps) => {
  return [
    resetClassNames,
    !disabled && 'cursor-pointer',
    paddingClassNames[padding],
    radiusClassNames[radius],
    variantClassNames[appearance],
  ];
};
